import { gql } from "@/services/httpAdapter";

const PerformanceFragment = gql`
	fragment Performance on WashoutAdvisorPerformance {
		repairOrders {
			_id
			department
			repairOrderNumber
			date
			customerPay {
				labor {
					percentage
					amount
					hours
				}
				parts {
					percentage
					amount
				}
			}
			warranty {
				labor {
					percentage
					amount
					hours
				}
				parts {
					percentage
					amount
				}
			}
			internal {
				labor {
					percentage
					amount
					hours
				}
				parts {
					percentage
					amount
				}
			}
			subletGross
			discountPercentage
			discountAmount
			repairOrderCount
			totalGross
			commission {
				labor
				parts
				total
			}
		}
		totals {
			customerPay {
				labor {
					percentage
					amount
					hours
				}
				parts {
					percentage
					amount
				}
				effectiveLaborRate
				averageHoursPerRepairOrder
			}
			internal {
				labor {
					percentage
					amount
					hours
				}
				parts {
					percentage
					amount
				}
				effectiveLaborRate
				averageHoursPerRepairOrder
			}
			warranty {
				labor {
					percentage
					amount
					hours
				}
				parts {
					percentage
					amount
				}
				effectiveLaborRate
				averageHoursPerRepairOrder
			}
		}
	}
`;

const AdvisorsStoreMetricsTotalsFragment = gql`
	fragment StoreMetricsTotals on StoreMetricsTotals {
		effectiveLaborRate
		averageHoursPerRepairOrder
	}
`;

const AdvisorsStoreMetricsFragment = gql`
	fragment AdvisorsStoreMetrics on WashoutAdvisorStoreMetrics {
		customerPay {
			...StoreMetricsTotals
		}
		internal {
			...StoreMetricsTotals
		}
		warranty {
			...StoreMetricsTotals
		}
		totals {
			...StoreMetricsTotals
		}
	}
	${AdvisorsStoreMetricsTotalsFragment}
`;

export { AdvisorsStoreMetricsFragment, PerformanceFragment };
